<ng-container *ngIf="showWelcomeModal">
	<div class="welcome-enroll-overlay" aria-hidden="true"></div>

	<section class="welcome-enroll-modal" role="dialog" aria-modal="true" aria-label="Boas-vindas iFood">
		<button
			type="button"
			class="welcome-enroll-modal__close"
			aria-label="Fechar"
			(click)="closeModal()"
		>
			<img
				[src]="'images/ifood-landing/cross.svg' | assetsUrl"
				alt=""
				class="welcome-enroll-modal__close-icon"
			/>
		</button>
		<img
			*ngIf="!isClube"
			[src]="'images/ifood-landing/header-ifood.svg' | assetsUrl"
			alt="Boas-vindas iFood"
			class="welcome-enroll-modal__image"
		/>
		<img
			*ngIf="isClube"
			[src]="'images/ifood-landing/header-clube.svg' | assetsUrl"
			alt="Boas-vindas Clube"
			class="welcome-enroll-modal__image"
		/>
		<div class="welcome-enroll-modal__title-wrapper">
			<h2 class="welcome-enroll-modal__title">Boas-vindas viajante!</h2>
		</div>
		<div class="welcome-enroll-modal__content-wrapper">
			<div class="welcome-enroll-modal__content">
				<p *ngIf="!isClube" class="welcome-enroll-modal__subtitle">
					Agora seus pedidos no iFood geram pontos para viajar mais com a Decolar
				</p>
				<p *ngIf="isClube" class="welcome-enroll-modal__subtitle">
					Você ganhou de presente do Clube
				</p>
				<div *ngIf="isClube" class="welcome-enroll-modal__club-points">
					<img
						[src]="'images/ifood-landing/clube-points.svg' | assetsUrl"
						alt="Pontos do Clube"
						class="welcome-enroll-modal__club-points-icon"
					/>
					<p class="welcome-enroll-modal__club-points-text">2.500 pontos</p>
				</div>
			</div>
		</div>
		<div *ngIf="enrolledEmail" class="welcome-enroll-modal__feature-wrapper">
			<div class="welcome-enroll-modal__feature-row">
				<div class="welcome-enroll-modal__feature-box">
					<img
						[src]="'images/ifood-landing/boas-vindas-brand.svg' | assetsUrl"
						alt="Marca Decolar"
						class="welcome-enroll-modal__feature-icon"
					/>
				</div>
				<div class="welcome-enroll-modal__feature-content">
					<p *ngIf="!isClube" class="welcome-enroll-modal__feature-text">Use sempre esse email na Decolar</p>
					<p *ngIf="isClube" class="welcome-enroll-modal__feature-text">Você precisa estar logado com este e-mail para ver seus pontos</p>					
					<p class="welcome-enroll-modal__feature-email">{{ enrolledEmail }}</p>
				</div>
			</div>
		</div>
		<div class="welcome-enroll-modal__actions">
			<button type="button" class="welcome-enroll-modal__share-button" (click)="onMainActionClick()">
				{{ isWebView ? 'Compartilhar benefício' : 'Baixar App Decolar' }}
			</button>
			<button type="button" class="welcome-enroll-modal__benefits-button" (click)="closeModal()">
				Ver benefícios
			</button>
		</div>
	</section>
</ng-container>
